var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00143 7V6.86322C5.00143 5.50563 4.93516 3.99239 5.70448 3.02078C6.14321 2.4667 6.85314 2 8 2C9.14686 2 9.85679 2.4667 10.2955 3.02078C11.0648 3.99239 10.9986 5.50563 10.9986 6.86322V7M3 7.82353C3 7.36869 3 7 3 7H13V12.3529C13 13.2626 13 14 13 14H3C3 14 3 13.2626 3 12.3529V7.82353Z",
    stroke: "#020617",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.a52d2847a66e1eb276ce4f86e3a1c231.svg";
export { ForwardRef as ReactComponent };